import React, { Component } from "react";
import Proptypes from "prop-types";
import Slider from "react-slick";
import { Helmet } from "react-helmet";
import { ImageContainer } from "./style";

class ImageCarousel extends Component {
	render() {
		const { heading, images } = this.props;

		const settings = {
			dots: false,
			infinite: true,
			speed: 500,
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1300,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
						dots: false,
					},
				},
				{
					breakpoint: 760,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: false,
					},
				},
			],
		};

		return (
			<div>
				<Helmet>
					<link
						rel="stylesheet"
						type="text/css"
						charset="UTF-8"
						href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
					/>
					<link
						rel="stylesheet"
						type="text/css"
						href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
					/>
				</Helmet>
				<ImageContainer>
					{heading && <div className="heading">{heading}</div>}
					<Slider {...settings}>
						{images.map((image, index) => {
							return (
								<div key={index}>
									<img src={image.imageUrl} />
								</div>
							);
						})}
					</Slider>
				</ImageContainer>
			</div>
		);
	}
}

ImageCarousel.propTypes = {
	header: Proptypes.string,
	images: Proptypes.array,
};

ImageCarousel.defaultProps = {
	header: "",
	images: [],
};

export default ImageCarousel;
